// src/auth/AuthContext.js
import React, { createContext, useState, useEffect } from "react";
import { Navigate, useNavigate } from "react-router-dom";

const API_BASE = process.env.REACT_APP_API_BASE_URL;

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [accessToken, setAccessToken] = useState(localStorage.getItem("access"));
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const init = async () => {
      if (accessToken) {
        await fetchUser(accessToken);
      }
      setLoading(false);
    };
    init();
  }, [accessToken]);

  const fetchUser = async (token) => {
    try {
        const res = await fetch(`${API_BASE}/api/users/me/`, {
        headers: { Authorization: `Bearer ${token}` },
        });
        if (res.ok) {
        const data = await res.json();
        setUser(data);
        } else if (res.status === 401) {
        const refreshed = await refreshAccessToken();
        if (refreshed) {
            await fetchUser(localStorage.getItem("access"));
        } else {
            logout();
        }
        }
    } catch {
        logout();
    }
    };

  const refreshAccessToken = async () => {
    const refresh = localStorage.getItem("refresh");
    if (!refresh) return false;

    const res = await fetch(`${API_BASE}/api/users/refresh/`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ refresh }),
    });

    if (res.ok) {
        const data = await res.json();
        localStorage.setItem("access", data.access);
        setAccessToken(data.access);
        return true;
    } else {
        logout();
        return false;
    }
    };


  const login = async (username, password) => {
    const res = await fetch(`${API_BASE}/api/users/login/`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ username, password }),
    });

    if (res.ok) {
      const data = await res.json();
      localStorage.setItem("access", data.access);
      localStorage.setItem("refresh", data.refresh);
      setAccessToken(data.access);
      await fetchUser(data.access);
      return true;
    } else {
      let errorMessage = "Niepoprawne dane logowania.";

      try {
        const data = await res.json();
        if (data.detail) {
          errorMessage = data.detail;
        }
      } catch (e) {}

      throw new Error(errorMessage);
    }
  };

  const logout = () => {
    localStorage.removeItem("access");
    localStorage.removeItem("refresh");
    setUser(null);
    setAccessToken(null);
    navigate("/");
    document.location.reload();
  };

  const register = async (username, email, password) => {
    const res = await fetch(`${API_BASE}/api/users/register/`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ username, email, password }),
    });
    if (res.ok) {
      // rejestracja się udała
      return true;
    } else {
      let errorMessage = "Nie udało się zarejestrować.";

      try {
        const data = await res.json();

        // DRF: {"email": ["Konto z tym adresem e-mail już istnieje."]}
        if (data.email && Array.isArray(data.email) && data.email[0]) {
          errorMessage = data.email[0];
        } else if (data.username && Array.isArray(data.username) && data.username[0]) {
          errorMessage = data.username[0];
        } else if (data.non_field_errors && Array.isArray(data.non_field_errors) && data.non_field_errors[0]) {
          errorMessage = data.non_field_errors[0];
        }
      } catch (e) {
        // jak nie da się sparsować JSON – zostawiamy defaultowy komunikat
      }

      // 🔴 Klucz: rzucamy Error z konkretną wiadomością
      throw new Error(errorMessage);
    }
  };

  return (
    <AuthContext.Provider value={{ user, accessToken,login, register, logout, loading }}>
      {!loading ? children : <div className="text-center mt-5">Ładowanie...</div>}
    </AuthContext.Provider>
  );
};
